import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import ValidationTabs from './ValidationTabs';

const {Text, Paragraph} = Typography;
const Content = Layout;

const ValidationLogic = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title2' style={{color: appColors['ColorNa']}}>User validation</Paragraph>
        <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-8vh'}}><b>Stakeholders fot the implementation of the test</b></Paragraph>
        <Text className='BaseText'>To make available iMoAge to the elderly population, we need to know the opinion of different sectors that are involved in the process of implementation of the test like public health, healthcare, and civil society. </Text>
        <ValidationTabs/>
      </Content>
      <Divider/>
    </Layout>
  );
};
export default ValidationLogic;
